import type { ValueFormatterParams } from "ag-grid-enterprise";

/**
 *  Formats numbers and return as strings.
 *  Use the digits parameter to enforce a specific rounding
 */
export function baseNumberFormatter(
  params: Partial<ValueFormatterParams>,
  digits: number | null = null
) {
  if (params.value == null) {
    return "";
  }

  let value = Number(params.value);
  if (Object.is(value, -0)) {
    value = 0;
  }

  if (Number.isNaN(value)) {
    // If value cannot be parsed to a number, return an empty string to avoid displaying 'NaN' in the cell
    return "";
  }

  /* If value is int and no digits are specified, return int formatted with thousand separators */
  if (Number.isInteger(value) && digits === null) {
    return value.toLocaleString("en-US");
  }

  // Normalize near-zero values (e.g. -0.001) to exactly 0
  if (Math.abs(value) < 1e-3) {
    value = 0.0;
  }

  /* Apply the specified decimal places, or default to 2 if not provided */
  return value.toLocaleString("en-US", {
    minimumFractionDigits: digits ?? 2,
    maximumFractionDigits: digits ?? 2
  });
}
